import React from 'react';
import Svg from '../Svg';

interface ILogoIconProps {
  children?: React.ReactNode;
  className: string;
}

export default function LogoMobileIcon(props: ILogoIconProps): JSX.Element {
  return (
    <Svg width="29" height="24" fill="none" viewBox="0 0 29 24" {...props}>
      <path
        d="M9.742 0a4.09 4.09 0 0 1 1.606.328c.25.106.496.218.732.346a7.629 7.629 0 0 1 3.625 4.606c.46 1.457.83 2.942 1.201 4.426.167.667.334 1.334.508 1.998l.219.833a174.7 174.7 0 0 0 1.011 3.747c.065.227.309.542.496.561a.965.965 0 0 0 .664-.403c.113-.145.21-.302.309-.46.134-.215.27-.433.447-.631L17.411 24c-.027-.025-.056-.048-.085-.07-.057-.044-.11-.086-.133-.14a97.558 97.558 0 0 1-3.732-10.43l-.024-.082c-.753-2.575-1.509-5.155-2.436-7.671A9.665 9.665 0 0 0 6.489.54C6.25.401 5.882.27 5.601.167 5.39.091 5.226.031 5.201 0h4.541ZM3.983.484C5.79.9 6.5 1.85 7.383 3.034l.062.084A31.955 31.955 0 0 1 9.082 5.53a11.516 11.516 0 0 1-4.15-1.586 25.289 25.289 0 0 1-2.425-2.12A21.756 21.756 0 0 0 0 .174a24.344 24.344 0 0 1 3.983.31Zm20.778 2.161c.164-.573.75-2.624-2.628-2.645H29l-.077.012c-2.457-.061-3.227 1.998-3.48 2.674l-.047.12c-.198.496-2.483 6.264-2.483 6.264s1.665-5.723 1.826-6.343l.022-.082Z"
        fill="#4D4048"
      />
    </Svg>
  );
}
